import { useUIStore } from '../stores/UIStore';

export const UseThemeMode = () => {
  const themeMode = useUIStore(state => state.themeMode);
  const setThemeMode = useUIStore(state => state.setThemeMode);

  const handleThemeToggle = () => {
    const newThemeMode = themeMode === 'light' ? 'dark' : 'light';
    setThemeMode(newThemeMode);
    document.body.classList.remove(themeMode);
    document.body.classList.add(newThemeMode);
  };
  return {
    themeMode,
    setThemeMode,
    handleThemeToggle,
  };
};
